import { Injectable } from '@angular/core';
import { BaseRequestOptions, Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { TranslateService } from 'ng2-translate';
import { isNull } from 'util';
import { UtilsService } from '../../shared/utils/utils.service';
import { CampaignService } from '../campaign/campaign.service';
import { Master } from './master.model';

@Injectable()
export class MasterService {

    private resourceUrl = 'api/masters';
    private resourceInterneUrl = 'api/interne/masters';
    constructor(
        private http: Http,
        public translateService: TranslateService,
        public utilsService: UtilsService,
        private campaignService: CampaignService
    ) { }

    create(master: Master): Observable<Master> {
        let copy: Master = Object.assign({}, master);
        return this.http.post(this.resourceInterneUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(master: Master): Observable<Master> {
        let copy: Master = Object.assign({}, master);
        return this.http.put(this.resourceInterneUrl, copy).map((res: Response) => {
            return this.convertRes(res);
        });
    }

    find(id: number): Observable<Master> {
        return this.http.get(`${this.resourceInterneUrl}/${id}`).map((res: Response) => {
            return this.convertRes(res);
        });
    }
    getMasters(): Observable<Master[]> {
        let options = this.createRequestOption({ campaign: this.campaignService.getDisplayedCampaign() });
        return this.http.get(this.resourceUrl, options)
            .map((res: Response) => {
                return this.convertResponse(res)._body;
            });
    }

    getMastersFilteredByMention(mention: string): Observable<Master[]> {
        let options = this.createRequestOption({ campaign: this.campaignService.getDisplayedCampaign(), licence: mention });
        return this.http.get(this.resourceUrl, options).map((res: any) => {
            return this.convertResponse(res)._body;
        });
    }

    query(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
            ;
    }

    mgntquery(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceInterneUrl, options)
            .map((res: any) => this.convertResponse(res))
            ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceInterneUrl}/${id}`);
    }

    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {

            jsonResponse[i].formationLabel = jsonResponse[i].masterLabel;
            if (jsonResponse[i].specialityLabel) {
                jsonResponse[i].formationLabel += ' - ' + jsonResponse[i].specialityLabel;
            }
            jsonResponse[i].masterTitle = jsonResponse[i].masterSchoolName + ' - ' + jsonResponse[i].formationLabel + ' - ' + jsonResponse[i].masterInm;

            if (isNull(jsonResponse[i].residualVacantPlaces)) {
                jsonResponse[i].residualVacantPlacesDisplayed = 'Non renseignées';
                jsonResponse[i].availablePlacesDisplayed = '';
            } else {
                jsonResponse[i].residualVacantPlacesDisplayed = jsonResponse[i].residualVacantPlaces + ' ';
                jsonResponse[i].availablePlaces = jsonResponse[i].residualVacantPlaces - jsonResponse[i].attributedPlaces;
                jsonResponse[i].availablePlacesDisplayed = jsonResponse[i].availablePlaces + ' ';
            }
        }
        res._body = jsonResponse;
        return res;
    }

    private convertRes(res: any): any {
        let jsonResponse = res.json();
        if (isNull(jsonResponse.residualVacantPlaces)) {
            jsonResponse.residualVacantPlacesDisplayed = 'Non renseignées';
            jsonResponse.availablePlacesDisplayed = '';
        } else {
            jsonResponse.residualVacantPlacesDisplayed = jsonResponse.residualVacantPlaces + ' ';
            jsonResponse.availablePlaces = jsonResponse.residualVacantPlaces - jsonResponse.attributedPlaces;
            jsonResponse.availablePlacesDisplayed = jsonResponse.availablePlaces + ' ';
        }
        return jsonResponse;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            params.set('campaign', req.campaign);
            params.set('licence', req.licence);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }


    public getMasterTitle(master: Master): string {
        if (master) {
            if (master.specialityLabel) {
                return master.masterSchoolName + ' - ' + master.masterLabel + ' - ' + master.specialityLabel + ' - ' + master.masterInm;
            } else {
                return master.masterSchoolName + ' - ' + master.masterLabel + ' - ' + master.masterInm;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master/master.service.ts